import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37900e97"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative" }
const _hoisted_2 = {
  key: 0,
  class: "absolute inset-0 bg-gray-100 bg-opacity-75 flex justify-center items-center z-50"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-700 text-lg" }, "Loading...", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "table min-w-full divide-y divide-gray-200" }
const _hoisted_7 = { class: "bg-gray-50" }
const _hoisted_8 = { class: "text-xs text-gray-500 uppercase" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "pointer"
}
const _hoisted_11 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["src"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = ["src"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Use setting", -1))
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Use setting", -1))
const _hoisted_21 = { key: 5 }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { key: 6 }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = { class: "flex" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = ["onClick", "onContextmenu"]
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = {
  key: 1,
  class: "flex mx-auto"
}
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { key: 8 }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { key: 9 }
const _hoisted_38 = ["onClick"]

import { ref, shallowRef, resolveComponent } from "vue";
import PopOver from "@/components/tools/PopOver.vue";
import type { PropType } from "vue";
import { Switch } from "@headlessui/vue";
import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'DataTable',
  props: {
  columns: Array as PropType<
    {
      label: string;
      field: string;
      align?: string;
      sort?: boolean;
      isEdit?: (data: any) => boolean;
      isSorted?: boolean;
      isButton?: boolean;
      isToggle?: boolean;
      isIconActive?: boolean;
      isHTML?: boolean;
      isIconFunction?: boolean;
      isIconCopy?: boolean;
      isFunction?: boolean;
      isSettle?: boolean;
      isRow?: boolean;
      isImage?: boolean;
      isImages?: boolean;
      buttonTitle?: string;
      element?: any;
      elementValue?: (value: any) => any;
      elementClass?: string;
      permission?: string;
      format?: (value: string) => string;
      checkValue?: (value: string) => string;
      class?: (value: any) => string;
      styles?: any;
      function?: (data?: any) => any;
      auxClick?: (data: any) => any;
      iconRef?: (data: any) => any;
      isAuxClick?: boolean;
      style?: (value: string) => string;
    }[]
  >,
  data: Array as PropType<any>,
  isLoaded: {
    type: Boolean,
    default: true, // ตั้งค่าเริ่มต้นเป็น true เพื่อไม่ให้แสดง loader หากไม่มีการส่งค่า
  },
},
  emits: ["sort", "showDetailTable", "cancel", "resettle", "edit"],
  setup(__props, { emit }) {

const store = useStore();





const toggle = ref<boolean>(false);

const onToggle = (column: any) => {
  const { label, sort } = column;
  if (sort) {
    toggle.value = !toggle.value;
    emit("sort", label);
  }
};

const checkAmountColor = (amount: number) => {
  if (amount > 0) {
    return { color: "red", value: amount };
  }
  return { color: "green", value: amount };
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.isLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : _createCommentVNode("", true),
    _createElementVNode("table", _hoisted_6, [
      _createElementVNode("thead", _hoisted_7, [
        _createElementVNode("tr", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (column, i) => {
            return (_openBlock(), _createElementBlock("th", {
              scope: "col",
              class: _normalizeClass(["px-6 py-3 font-medium tracking-wider", `text-${column.align || 'left'}`]),
              key: i
            }, [
              (column.permission ? _unref(store).state.user.permissions.includes(column.permission) : true)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "row gap-2",
                    onClick: ($event: any) => (onToggle(column))
                  }, [
                    _createTextVNode(_toDisplayString(column.label) + " ", 1),
                    (column.sort)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                          (column.isSorted == true)
                            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                key: 0,
                                class: "text-gray-500",
                                transform: "shrink-2",
                                icon: ['far', 'sort-up']
                              }))
                            : _createCommentVNode("", true),
                          (column.isSorted == false)
                            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                key: 1,
                                class: "text-gray-500",
                                transform: "shrink-2",
                                icon: ['far', 'sort-down']
                              }))
                            : _createCommentVNode("", true),
                          (column.isSorted == null)
                            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                key: 2,
                                class: "text-gray-500",
                                transform: "shrink-2",
                                icon: ['far', 'sort']
                              }))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_9))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ])
      ]),
      _createElementVNode("tbody", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (row, i) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: i,
            class: "hover:bg-gray-50"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (column, j) => {
              return (_openBlock(), _createElementBlock("td", {
                class: _normalizeClass(["px-6 py-4 whitespace-wrap text-sm text-gray-500", `text-${column.align || 'left'}`]),
                style: _normalizeStyle(column?.styles?.td),
                key: j
              }, [
                (column.isImage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("img", {
                        src: row.imageUrl,
                        class: "w-32 h-20 rounded object-contain"
                      }, null, 8, _hoisted_13)
                    ]))
                  : _createCommentVNode("", true),
                (column.isImages && row.images[0]?.url)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("img", {
                        src: row.images[0].url,
                        class: "w-32 h-20 rounded object-contain"
                      }, null, 8, _hoisted_15)
                    ]))
                  : _createCommentVNode("", true),
                (column.isIconActive)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 2,
                      class: _normalizeClass(column.class && column?.class(row))
                    }, [
                      (row.isActive)
                        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                            key: 0,
                            class: "text-green-600",
                            icon: ['fas', 'check-circle']
                          }))
                        : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                            key: 1,
                            class: "text-blue-600",
                            icon: ['fas', 'times-circle']
                          }))
                    ], 2))
                  : (column.element)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        (column.permission ? _unref(store).state.user.permissions.includes(column.permission) : true)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass(column.class ? column.class(row) : null),
                              onClick: ($event: any) => (column.isFunction ? column.function(row) : null)
                            }, [
                              (_openBlock(), _createBlock(_resolveDynamicComponent(column.element), {
                                class: _normalizeClass(column.elementClass ? column.elementClass : ''),
                                title: column.format ? column.format(row) : 'title',
                                data: row,
                                manualValue: column.elementValue ? column.elementValue(row) : undefined
                              }, null, 8, ["class", "title", "data", "manualValue"]))
                            ], 10, _hoisted_16))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (column.isToggle)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                          (column.permission ? _unref(store).state.user.permissions.includes(column.permission) : true)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass(column.class && column?.class(row))
                              }, [
                                (row.is_active)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                      _createVNode(_unref(Switch), {
                                        modelValue: row.is_active,
                                        "onUpdate:modelValue": ($event: any) => ((row.is_active) = $event),
                                        class: _normalizeClass([row.is_active ? 'bg-blue-500' : 'bg-red-900', "relative inline-flex flex-shrink-0 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75"]),
                                        onClick: ($event: any) => (column.function(row)),
                                        style: {"height":"38px","width":"74px"}
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_18,
                                          _createElementVNode("span", {
                                            style: {"width":"34px","height":"34px"},
                                            class: _normalizeClass([row.is_active ? 'translate-x-9' : 'translate-x-0', "pointer-events-none inline-block rounded-full bg-white shadow-lg transform ring-0 transition ease-in-out duration-200"])
                                          }, null, 2)
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "class", "onClick"])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                      _createVNode(_unref(Switch), {
                                        modelValue: row.isActive,
                                        "onUpdate:modelValue": ($event: any) => ((row.isActive) = $event),
                                        class: _normalizeClass([row.isActive ? 'bg-blue-500' : 'bg-red-900', "relative inline-flex flex-shrink-0 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75"]),
                                        onClick: ($event: any) => (column.function(row)),
                                        style: {"height":"38px","width":"74px"}
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_20,
                                          _createElementVNode("span", {
                                            style: {"width":"34px","height":"34px"},
                                            class: _normalizeClass([row.isActive ? 'translate-x-9' : 'translate-x-0', "pointer-events-none inline-block rounded-full bg-white shadow-lg transform ring-0 transition ease-in-out duration-200"])
                                          }, null, 2)
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "class", "onClick"])
                                    ]))
                              ], 2))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (column.isSettle)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                            (
                _unref(store).state.user.permissions.includes('GAME.FORCE_STATUS') ||
                _unref(store).state.user.permissions.includes('GAME.FORCE_UPDATE')
              )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                  (row.action && row.action === 'BET')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                        _createElementVNode("button", {
                                          class: "text-white bg-red-500 p-1 w-14 rounded my-3",
                                          onClick: ($event: any) => (_ctx.$emit('cancel', row))
                                        }, " cancel ", 8, _hoisted_24),
                                        _createElementVNode("button", {
                                          class: "text-white bg-green-500 p-1 w-14 rounded",
                                          onClick: ($event: any) => (_ctx.$emit('resettle', row))
                                        }, " resettle ", 8, _hoisted_25)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : (column.isHTML)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                              _createElementVNode("div", {
                                class: "text-xs flex flex-col text-left",
                                innerHTML: column.format(row)
                              }, null, 8, _hoisted_27)
                            ]))
                          : (!column.isButton)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                (column.permission ? _unref(store).state.user.permissions.includes(column.permission) : true)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: _normalizeClass(column.class && column?.class(row))
                                    }, [
                                      _createElementVNode("div", _hoisted_28, [
                                        (column.isIconFunction)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                              _createElementVNode("a", {
                                                href: "javasctipt:void(0)",
                                                onClick: ($event: any) => (column.function(row)),
                                                onContextmenu: (e) => {
                    e.preventDefault();
                    if (column.auxClick) column.auxClick(row);
                    return false;
                  }
                    
                                              }, [
                                                (column.isIconCopy)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_31, [
                                                      _createVNode(_component_font_awesome_icon, {
                                                        class: "text-gray-500 mr-2",
                                                        icon: ['far', 'copy']
                                                      })
                                                    ]))
                                                  : (_openBlock(), _createElementBlock("span", _hoisted_32, [
                                                      _createVNode(_component_font_awesome_icon, {
                                                        class: "text-gray-500 mr-2",
                                                        icon: ['far', 'file-alt']
                                                      })
                                                    ]))
                                              ], 40, _hoisted_30)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (column.isFunction)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                              (column.permission ? _unref(store).state.user.permissions.includes(column.permission) : true)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    class: _normalizeClass([column.class && column?.class(row), "px-3 py-1 rounded-md shadow-sm text-sm font-medium"]),
                                                    onClick: ($event: any) => (column.function(row))
                                                  }, _toDisplayString(column.format ? column.format(row) : row[column.field]), 11, _hoisted_34))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : (_openBlock(), _createElementBlock("div", {
                                              key: 2,
                                              class: _normalizeClass([column.class && column?.class(row), "px-1"]),
                                              style: _normalizeStyle(column.style && column?.style(row))
                                            }, _toDisplayString(column.format ? column.format(row) : row[column.field]), 7))
                                      ])
                                    ], 2))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : (_openBlock(), _createElementBlock("span", _hoisted_35, [
                                _createElementVNode("button", {
                                  type: "button",
                                  href: "javascript:void(0)",
                                  onClick: ($event: any) => (column.isRow ? _ctx.$emit('showDetailTable', row) : _ctx.$emit('showDetailTable', row[column.field])),
                                  class: "inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-600"
                                }, " View Detail ", 8, _hoisted_36)
                              ])),
                (column.isEdit)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_37, [
                      (column.permission ? _unref(store).state.user.permissions.includes(column.permission) : true)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            href: "javascript:void(0)",
                            onClick: ($event: any) => (_ctx.$emit('edit', row)),
                            class: "inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-600"
                          }, _toDisplayString(column.checkValue ? column.checkValue(row) : "Edit"), 9, _hoisted_38))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ], 6))
            }), 128))
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})